"use client";

import { useEffect, useState } from "react";
import { getBotbPrizeStraplineTexts } from "@/app/(general-header)/botb-pass/subscription-service";

type PrizeStraplineTexts = {
  PrizeStraplineText1: string;
  PrizeStraplineText2: string;
  PrizeStraplineText3: string;
};

/**
 * The CMS-held trust figures — years trading and total prizes given.
 *
 * Same call /botb-pass makes for its own specs strip, so both pages quote the
 * same numbers. Starts blank rather than with placeholder figures: the strip
 * renders its icons and labels immediately and the values fill in.
 */
export default function usePrizeStraplineTexts() {
  const [straplines, setStraplines] = useState<PrizeStraplineTexts>({
    PrizeStraplineText1: "",
    PrizeStraplineText2: "",
    PrizeStraplineText3: "",
  });

  useEffect(() => {
    getBotbPrizeStraplineTexts()
      .then(response => response.json())
      .then((data: PrizeStraplineTexts) => setStraplines(data))
      .catch(error => console.error("Error fetching prize strapline texts:", error));
  }, []);

  return straplines;
}
